export default "__VITE_ASSET__BEOI9MmD__"